import React from 'react';
import Button from '~/components/Button';
import JustificationContainer from '~/components/JustificationContainer';
import TextButton from '~/components/TextButton';
import AppDetailsContainer from '~/scenes/Apps/components/AppDetailsContainer';
import { StepProps } from '../Connect';
import ChatComponent from './components/ChatComponent';
import Instructions from './components/Instructions';
import {
  firstVariantOfInstructions,
  secondVariantOfInstructions,
} from './instructionsText';
import TEST_ID from './index.testid';
import { Body } from '~/components/Typography/index';

const text = {
  header: 'Volgende stappen',
  pageDescription:
    'Het inrichten van de Zapier koppeling is gelukt! Om je Zapier koppeling aan het werk te zetten, moet je nog een aantal stappen uitvoeren in zowel Zapier als in DatHuis. We leggen het kort uit.',
  firstInstructionHeader: 'Wil je contacten in Zapier verwerken?',
  secondInstructionHeader:
    'Wil je contacten vanuit Zapier in DatHuis ontvangen?',
  chatHeader:
    'Op zoek naar ideeen hoe je met Zapier jouw marketing een boost geeft?',
  chatLinkText: 'Start een chat met ons!',
  buttonLabel: 'Afronden',
  exitButtonLabel: 'Afbreken',
};

const FinalStep: React.FC<StepProps> = ({
  onClose,
  disableClosing = false,
}) => (
  <AppDetailsContainer
    header={text.header}
    icon="list"
    dataTestId={TEST_ID.CONTAINER}
  >
    <Body withoutMargin>{text.pageDescription}</Body>
    <Instructions
      header={text.firstInstructionHeader}
      instructions={firstVariantOfInstructions}
    />
    <Instructions
      header={text.secondInstructionHeader}
      instructions={secondVariantOfInstructions}
    />
    <ChatComponent header={text.chatHeader} linkText={text.chatLinkText} />
    <JustificationContainer justification="space-between" align="center">
      {!disableClosing && (
        <TextButton
          label={text.exitButtonLabel}
          onClick={onClose}
          withoutPadding
          appearance="danger"
          type="button"
          dataTestId="exit-wizard-button"
        />
      )}
      <Button
        label={text.buttonLabel}
        icon="arrowRight"
        size="medium"
        onClick={onClose}
        dataTestId={TEST_ID.COMPLETE_BUTTON}
      />
    </JustificationContainer>
  </AppDetailsContainer>
);

export default FinalStep;
